// ═══ ФОТО МАШИН ═══
//
// Больше половины фракционного транспорта — модели из паков (markii, auditt,
// polbuffalog…), и в фотобазе на нашем CDN файлов с ТАКИМИ именами нет —
// карточки оставались пустыми. Разгадка: сами картинки на CDN ЕСТЬ, но лежат
// под именами Мажестика (mark2, tt, buffalo3…). Этот словарь переводит наше
// имя модели в имя файла фотобазы — все ссылки остаются на нашем CDN, никаких
// внешних источников.
//
// Подбор пар проверен глазами по контрольному листу рендеров (16.08.2026).
// У пяти моделей точного файла в базе нет — стоит ближайшая машина той же
// марки/кузова (jeepsrt8→durango, porschegt4→carrera, lexusgsf→lc500,
// m750li→oracle2, mbc63/s→c200).

const BASE = 'https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/';

const ALIAS = {
    // паковые машины → имя файла в фотобазе
    audirs7: 'rs7',        auditt: 'tt',          barricade2: 'dominator3',
    bentleyc: 'continental', bmwm5: 'm5comp',     bmwm8: 'm850',
    bmwx6: 'x6m',          c7: 'corvette2',       dodgecharger: 'charger20',
    escalade900: 'escalade2', impala67: 'impala', jeepsrt8: 'durango',
    lambo580: 'huracan',   lambo640: 'huracan2',  lambo770p: 'sian',
    lexusgsf: 'lc500',     lx570: 'lx600',        m750li: 'oracle2',
    markii: 'mark2',       mb63gls: 'gle63',      mbc63: 'c200',
    mbc63s: 'c200',        mbe420: 'w210',        mbg63: 'g63',
    mlevox: 'evo10',       panamera: 'panamera2', porschegt4: 'carrera',
    rrcullinan: 'cullinan', rrsvr: 'velar',       silvias15: 's15',
    subaruwrx: 'wrx',      supra: 'a80',          teslas: 'models',
    vapidse: 'speedo',

    // полицейские/государственные версии → базовая машина
    polalamog: 'sheriff',   polalamor: 'sheriff',    polbisonr: 'bison',
    polbuffaloc: 'buffalo3', polbuffalog: 'buffalo3', polbuffalor: 'buffalo3',
    polcarac: 'caracara',   polcmd: 'police4',       polcoquetteg: 'coquette',
    polfugitiver: 'fugitive', polpatriotf2: 'patriot', polsc1: 'police3',
    polscoutc: 'scout',     polscoutg: 'scout',      polscoutr: 'scout',
    polstalkerg: 'police2', polstanierr: 'stanier',  poltorencec: 'sheriff2',
    sahpgrowler: 'growler', sahpicv: 'police',       sahpneon: 'neon',
    umkalamo: 'granger',
    gov1: 'tailgater',      gov2: 'tailgater',       gov3: 'washington',
    gov4: 'stretch',        gov5: 'stretch',
};

/** Адрес фотографии машины по имени модели. */
export const vehiclePhoto = (model) => {
    const name = String(model || '').toLowerCase();
    return BASE + (ALIAS[name] || name) + '.png';
};

export default vehiclePhoto;
